<app-page [simpleTopBar]="globalVars.isMobile()" title="Voted By">
  <poll-details></poll-details>
</app-page>
